'use client'

import { useEffect } from 'react'
import { useIsClient } from 'usehooks-ts'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { MediaSelectContextProvider } from '@marketplace-web/item-upload/media-upload-feature'
import { ContentLoader } from '@marketplace-web/common-components/content-loader-ui'
import {
  getFaqNotLoggedInEntries,
  getTransaction,
  FaqEntryModel,
} from '@marketplace-web/help-center-support-tickets/help-center-support-tickets-data'

import ContactForm from './ContactForm'

type Props = {
  faqEntry?: FaqEntryModel
}

const SupportTickets = ({ faqEntry }: Props) => {
  const { faq_entry_id, transaction_id } = useBrowserNavigation().searchParams

  const transactionId = Number(transaction_id)
  const faqEntityId = Array.isArray(faq_entry_id) ? undefined : faq_entry_id

  const isClientSideRenderReady = useIsClient()

  const {
    fetch: fetchFaqNotLoggedInEntires,
    data: faqNotLoggedInEntriesData,
    isLoading: isFaqNotLoggedInEntriesLoading,
  } = useFetch(getFaqNotLoggedInEntries)

  const {
    fetch: fetchTransaction,
    data: transactionData,
    isLoading: isTransactionLoading,
  } = useFetch(getTransaction)

  useEffect(() => {
    fetchFaqNotLoggedInEntires()
    if (transactionId) fetchTransaction({ id: transactionId })
  }, [faqEntityId, fetchFaqNotLoggedInEntires, fetchTransaction, transactionId])

  const preselectedTransaction = transactionData?.transaction || null

  const isLoginTipDisplayed =
    !faqNotLoggedInEntriesData?.faq_entries.some(({ id }) => id === Number(faqEntityId)) || false

  if (isTransactionLoading || isFaqNotLoggedInEntriesLoading || !isClientSideRenderReady) {
    return (
      <ContentLoader
        styling={ContentLoader.Styling.Wide}
        size={ContentLoader.Size.Large}
        testId="contact-form-loader"
      />
    )
  }

  if (!faqEntry || !faqNotLoggedInEntriesData) return null

  return (
    <MediaSelectContextProvider>
      <ContactForm
        faqEntry={faqEntry}
        isLoginTipDisplayed={isLoginTipDisplayed}
        preselectedTransaction={preselectedTransaction}
        isEnglishAllowedVisible={!!faqEntry.englishAllowedVisible}
        photoEntryId={0}
      />
    </MediaSelectContextProvider>
  )
}

export default SupportTickets
